var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Drawer",
        {
          attrs: { drawer: _vm.drawer, title: "装载", size: 920 },
          on: { close: _vm.close },
        },
        [
          _c(
            "div",
            { staticClass: "view" },
            [
              _c("div", { staticClass: "sandway" }, [
                _c("div", { staticStyle: { flex: "1" } }, [
                  _c("span", { staticClass: "label" }, [_vm._v("派送方式")]),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.rowData.pickUpType === 1
                            ? `${_vm.tableData.columns[0]?.typeName}-${_vm.tableData.columns[0]?.code}`
                            : "回仓"
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "item",
                      staticStyle: {
                        height: "40px",
                        "line-height": "40px",
                        "margin-left": "8px",
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.sumQty) + " "),
                      _c(
                        "span",
                        {
                          staticClass: "sufix",
                          staticStyle: { "line-height": "40px" },
                        },
                        [_vm._v("件")]
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "item",
                      staticStyle: { height: "40px", "line-height": "40px" },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.sumWeight) + " "),
                      _c(
                        "span",
                        {
                          staticClass: "sufix",
                          staticStyle: { "line-height": "40px" },
                        },
                        [_vm._v("KG")]
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "item",
                      staticStyle: { height: "40px", "line-height": "40px" },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.sumSquare) + " "),
                      _c(
                        "span",
                        {
                          staticClass: "sufix",
                          staticStyle: { "line-height": "40px" },
                        },
                        [_vm._v("CBM")]
                      ),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible4 = true
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-circle-plus add" })]
                ),
                _c(
                  "div",
                  {
                    staticClass: "btn",
                    staticStyle: { "margin-left": "16px" },
                    on: { click: _vm.updateData },
                  },
                  [_c("i", { staticClass: "el-icon-edit add" })]
                ),
              ]),
              _c("BaseTable", {
                staticStyle: { "margin-top": "16px" },
                attrs: {
                  height: 480,
                  tableData: _vm.tableData,
                  isPager: false,
                  border: true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "typeName",
                    fn: function (row) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(row.scope.typeName) +
                            " " +
                            _vm._s(
                              row.scope.code ? `- ${row.scope.code}` : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "qty",
                    fn: function (row) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "item",
                            staticStyle: { width: "80px" },
                          },
                          [
                            _vm._v(" " + _vm._s(row.scope.qty || 0) + " "),
                            _c("span", { staticClass: "sufix" }, [
                              _vm._v("件"),
                            ]),
                          ]
                        ),
                        _c("span", { staticClass: "item" }, [
                          _vm._v(" " + _vm._s(row.scope.weight || 0) + " "),
                          _c("span", { staticClass: "sufix" }, [_vm._v("KG")]),
                        ]),
                        _c("span", { staticClass: "item" }, [
                          _vm._v(" " + _vm._s(row.scope.square || 0) + " "),
                          _c("span", { staticClass: "sufix" }, [_vm._v("CBM")]),
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteRow(row.scope)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                  {
                    key: "remarks",
                    fn: function (row) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom-end",
                              width: "426",
                              trigger: "click",
                            },
                          },
                          [
                            !row.scope.remarks
                              ? _c("img", {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: {
                                    slot: "reference",
                                    src: require("@/assets/images/bill/edit2.png"),
                                  },
                                  slot: "reference",
                                })
                              : _c("img", {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: {
                                    slot: "reference",
                                    src: require("@/assets/images/bill/message.png"),
                                  },
                                  slot: "reference",
                                }),
                            _c("div", { staticClass: "remark-area" }, [
                              _c("div", { staticClass: "title" }, [
                                _c("p", { staticClass: "lable" }, [
                                  _vm._v("备注内容"),
                                ]),
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "copy",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(row.scope)
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          "vertical-align": "-4px",
                                        },
                                        attrs: {
                                          width: "16",
                                          height: "16",
                                          src: require("@/assets/images/bill/edit2.png"),
                                        },
                                      }),
                                      _vm._v("修改 "),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "copy",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleCopy(
                                            row.scope.remarks
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          "vertical-align": "-4px",
                                        },
                                        attrs: {
                                          src: require("@/assets/images/bill/copy1.png"),
                                        },
                                      }),
                                      _vm._v("复制 "),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(" " + _vm._s(row.scope.remarks) + " "),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("ExportOrderDialog", {
            attrs: {
              dialogVisible: _vm.dialogVisible,
              sandwayObj: _vm.sandwayObj,
              rowData: _vm.rowData,
            },
            on: {
              ok: _vm.ok,
              cancel: function ($event) {
                _vm.dialogVisible = false
              },
            },
          }),
          _c("SelectOrderListDialog", {
            attrs: {
              dialogVisible: _vm.dialogVisible1,
              sandwayObj: _vm.sandwayObj,
              rowData: _vm.rowData,
            },
            on: {
              ok: _vm.ok,
              cancel: function ($event) {
                _vm.dialogVisible1 = false
              },
            },
          }),
          _c("OrderDetailDialog", {
            attrs: {
              dialogVisible: _vm.dialogVisible2,
              orderData: _vm.orderData,
              rowData: _vm.rowData,
              sendWay: _vm.sendWay,
            },
            on: {
              ok: _vm.ok,
              cancel: function ($event) {
                _vm.dialogVisible2 = false
              },
            },
          }),
          _c("EditRemarkDialog", {
            attrs: {
              dialogVisible: _vm.dialogVisible3,
              editData: _vm.editData,
            },
            on: {
              ok: _vm.ok,
              cancel: function ($event) {
                _vm.dialogVisible3 = false
              },
            },
          }),
          _c("AddSendwayDialog", {
            attrs: {
              dialogVisible: _vm.dialogVisible4,
              editTableData: _vm.editTableData,
              rowData: _vm.rowData,
            },
            on: {
              ok: function ($event) {
                _vm.dialogVisible4 = false
                _vm.getSendWay()
              },
              cancel: function ($event) {
                _vm.dialogVisible4 = false
                _vm.editTableData = []
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }